module.exports = __webpack_public_path__ + "static/image/history/pc/202503.ver2_0_2.jpg?33257a6f";